export default [

    {
        path: '/login',
        name: 'auth-login',
        component: () => import('@/views/authentication/Login.vue'),
        meta: {
            layout: 'full',
            resource: 'auth',
            action: 'read',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/register',
        name: 'auth-register',
        component: () => import('@/views/authentication/Register.vue'),
        meta: {
            layout: 'full',
            resource: 'auth',
            action: 'read',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/password/reset/',
        name: 'auth-reset-password',
        component: () => import('@/views/authentication/ForgotPassword.vue'),
        meta: {
            layout: 'full',
            resource: 'auth',
            action: 'read',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/password/reset/confirm/:uid/:token',
        name: 'auth-reset-password',
        component: () => import('@/views/authentication/ResetPassword.vue'),
        meta: {
            layout: 'full',
            resource: 'auth',
            action: 'read',
            redirectIfLoggedIn: true,
        },
    },

]
